import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import { dashboardOptions, dashboardOptionsNonStore } from "./dashboardOptions";
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { FaCaretDown } from "react-icons/fa";
import Select from "react-dropdown-select";
import { useAuth } from "../../contexts/AuthContext";
import moment from "moment";
import { apiUrls } from "../../utils/api/apiUrls";
import useApi from "../../hooks/useApi";
import DatePicker from "../../components/FormFields/DatePicker";
import { useMediaQuery } from "react-responsive";

const Dashboard = () => {
  const isMobileSmall = useMediaQuery({ query: "(max-width: 325px)" });
  const isMobileMid = useMediaQuery({ query: "(max-width: 375px)" });
  const isMobileFloor = useMediaQuery({ query: "(max-width: 425px)" });

  const { data = {}, apiCall } = useApi();
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(
    moment().subtract({ days: 7 }).toDate()
  );
  const [endDate, setEndDate] = useState(new Date());
  const onClickRaiseRequest = () => {
    navigate("/raisearequest");
  };

  const onClickSubmit = () => {
    navigate("/vouchers/submit", {state: {isEditFeatureOn: false}});
  };
  const {
    user: { userLabel, username },
    selectedStores,
    setCurrentTabSelect,
    storeDropdownState
  } = useAuth();
  const isStore = userLabel === "Store";

  const getArrayOfSelectedStores = (selectedStoreOption) =>{
    if(selectedStoreOption?.storeDetails?.storeCode === undefined){
      return [storeDropdownState?.[0]?.storeCode]
    }else if(selectedStoreOption?.storeDetails?.storeCode !== 'All'){
      return [selectedStoreOption?.storeDetails?.storeCode]
    }else{
      let storeCodeArray = [];
      storeDropdownState?.forEach((item)=>{
        storeCodeArray?.push(item?.storeCode)
      })
      return storeCodeArray
    }
  }

  const dashboardApiCall = (start, end, selectedStores) =>
    apiCall({
      url: apiUrls.dmsService.getDashboardData,
      method: "post",
      dataToSend: {
        startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
        endDate: moment(end || start)
          .endOf("d")
          .format("YYYY-MM-DD HH:mm:ss"),
        storeCodes: getArrayOfSelectedStores(selectedStores)
      },
    });

  useEffect(() => {
    if((!isStore && selectedStores[0]?.storeCode) || selectedStores?.storeDetails?.storeCode){
      dashboardApiCall(startDate, endDate, selectedStores, username);
    }
    if(isStore){
      dashboardApiCall(startDate, endDate, selectedStores, username);
    }
  }, [selectedStores,username ]);

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end !== null) dashboardApiCall(start, end, selectedStores);
  };

  const submittedVouchersList =
    !isStore && data?.managerDashboardResponse
      ? [
          {
            key:
              "All Stores - " +
              data?.managerDashboardResponse?.submittedVouchers,
            value:
              "All Stores - " +
              data?.managerDashboardResponse?.submittedVouchers,
          },
          ...data?.managerDashboardResponse?.storeWiseDashboardData?.map(
            (item) => ({
              key: `${item?.store} - ${item?.submittedVouchers}`,
              value: `${item?.store} - ${item?.submittedVouchers}`,
            })
          ),
        ]
      : [];

  console.log(data, "data");

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Dashboard"
        showBack={false}
        containerClassName="mt-14 mb-6"
        showStores
      />
      <DatePicker
        startDate={startDate}
        endDate={endDate}
        onChange={onChangeDate}
        dateRange
      />
      <div className="flex flex-wrap justify-between mt-6 gap-y-8">
        {(userLabel === "Store"
          ? dashboardOptions
          : dashboardOptionsNonStore
        ).map((item, index) => {
          return (
            <div
              className={`dashboard-option ${item?.cs || ""}`}
              key={"dashboard-option-" + index}
              onClick={() => {
                if (item?.link) {
                  navigate(item.link);
                }
                item?.tab && setCurrentTabSelect(item.tab || {});
              }}
            >
              <img
                src={item.icon}
                className={`${isMobileSmall ? 'w-[6.4rem] h-[6.4rem]' : "w-[7.4rem] h-[7.4rem]"}`}
                alt="dashboard option icon"
              />
              <div className={`${isMobileSmall ? 'font-size-extra-small' : 'font-size-small'} font-family-medium mt-4`}>
                {item.title}
              </div>

              {item?.showOptions &&
              !isStore &&
              submittedVouchersList?.length &&
              !selectedStores?.storeDetails ? (
                <Select
                  dropdownGap={-8}
                  wrapperClassName="!w-[100%]"
                  className="!border-[0px] !w-[24rem]"
                  options={submittedVouchersList}
                  labelField="key"
                  valueField="value"
                  contentRenderer={() => {
                    return (
                      <div className="flex items-center justify-center gap-x-3 !w-[100%]">
                        <div className={`${isMobileSmall ?  'text-[1.4rem]' : 'text-[2.4rem]'} text-[var(--appColor)] font-family-medium mt-2`}>
                          ₹ {Number(data?.["managerDashboardResponse"]?.[item.apiKey] || 0).toFixed(2) || '0'}
                        </div>

                        {item.showOptions && (
                          <FaCaretDown
                            size={22}
                            color="var(--appColor)"
                            className="mt-3"
                          />
                        )}
                      </div>
                    );
                  }}
                  itemRenderer={(item) => {
                    return (
                      <div className={"font-size-small my-2 px-8"}>
                        {item.item.key}
                      </div>
                    );
                  }}
                  dropdownHandle={false}
                />
              ) : (
                <div className={`${isMobileSmall ? 'text-[1.4rem]' : 'text-[2.4rem]'} text-[var(--appColor)] font-family-medium mt-2`}>
                  ₹{" "}
                  {
                    Number(data?.[
                      !isStore
                        ? "managerDashboardResponse"
                        : "storeDashboardResponse"
                    ]?.[item.apiKey] || 0).toFixed(2) || '0'
                  }
                </div>
              )}
              {!isStore && item?.title === "Submitted Vouchers" && (
                <div className="h-[6px] text-[#808080] text-[1.2rem]">
                  {data?.managerDashboardResponse?.submittedCountText}
                </div>
              )}
            </div>
          );
        })}

        {userLabel ? (
          <>
            {isStore ? (
              <div className="flex flex-col justify-between w-[100%] mt-10 gap-y-8">
                <CustomButton
                  title="Raise A Request"
                  wrapperClassName="!h-[7rem]"
                  textClassName="!text-[2.4rem]"
                  onClick={onClickRaiseRequest}
                />
                <CustomButton
                  title="Submit Your Vouchers"
                  wrapperClassName="!h-[7rem]"
                  textClassName="!text-[2.4rem]"
                  onClick={onClickSubmit}
                />
              </div>
            ) : (
              <div className="flex flex-col justify-between w-[100%] mt-10 gap-y-8">
                {userLabel === "L1" && (
                  <CustomButton
                    title="Approve Store Request"
                    wrapperClassName="!h-[7rem]"
                    textClassName="!text-[2.4rem]"
                    onClick={() => {
                      navigate("/request");
                    }}
                  />
                )}
                <CustomButton
                  title="Approve Vouchers"
                  wrapperClassName="!h-[7rem]"
                  textClassName="!text-[2.4rem]"
                  onClick={() => {
                    navigate("/vouchers");
                  }}
                />
              </div>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Dashboard;
